module.exports = __webpack_public_path__ + "img/healthPro5-EN.9e6b3afb.png";